import DefaultModal from 'components/Modal/DefaultModal';
import { LuEye } from 'react-icons/lu';
import React, { useEffect, useState } from 'react';

export const InfoModal = ({ assessment, title, agentName }) => {
  const [show, setShow] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [assessments, setAssessments] = useState([]);
  useEffect(() => {
    if (show && assessment) {
      handleGetAssessment(assessment);
    }
  }, [show, assessment]);

  const handleGetAssessment = async (assessment) => {
    setAssessments(assessment);
  };

  return (
    <>
      <DefaultModal
        show={show}
        onModalToggle={setShow}
        title={title}
        subtitle={<>{`Agente: ${agentName}`}</>}
        modalContainerClasses="modal-sm"
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '90%',
              flexDirection: 'column',
              flexWrap: 'wrap'
            }}
          >
            {assessments &&
              assessments.map((option, index) => {
                return (
                  <div
                    key={index}
                    className="timeline timeline-one-side mx-0"
                    data-timeline-axis-style="dotted"
                  >
                    <div className="timeline-block pb-3">
                      <span
                        className="timeline-step"
                        style={{ backgroundColor: '#5bc0de' }}
                      >
                        <i
                          className={'far fa-file-alt'}
                          //	fas fa-exchange-alt/	fas fa-level-down-alt/ fas fa-share
                          style={{ color: 'white' }}
                        ></i>
                      </span>
                      <div
                        className="timeline-content"
                        style={{ maxWidth: '50rem' }}
                      >
                        <strong>{option?.paper_name}</strong>
                      </div>
                      <small
                        className="text-muted font-weight-bold mt-1"
                        style={{ marginLeft: '3.8rem' }}
                      >
                        <i className="fas fa-user"></i>
                        {' ' + option?.author}
                      </small>
                      <br />
                      <small
                        className="text-muted font-weight-bold mt-1"
                        style={{ marginLeft: '3.8rem' }}
                      >
                        <i className="fas fa-star"></i>
                        {' ' + option?.overall_average}
                      </small>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </DefaultModal>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <button
          onClick={() => setShow(true)}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <LuEye />
        </button>
      </div>
    </>
  );
};
